/** Phosphor duotone presets — modern, readable icon weight across the shell */
export const ICON_DUOTONE = "duotone";

export const modernIcon = (size, weight = ICON_DUOTONE) => ({
  size,
  weight,
});

export const MODERN_ICON = {
  xs: modernIcon(14),
  sm: modernIcon(18),
  md: modernIcon(22),
  lg: modernIcon(24),
  rail: modernIcon(24),
  kpi: modernIcon(22),
  header: modernIcon(20),
};
